import React from "react";
import { useTranslation } from "react-i18next";
import { PageContainer } from "@outpave/ds";
import Role from "enums/Role";
import { useCheckUserRole } from "hooks/useCheckUserRole";
import UserNotificationSettingsTable from "components/common/notifications/UserNotificationSettingsTable";

/** The viewer's own notification preferences, the same page on /admin, /platform and /my. */
const NotificationSettingsPage: React.FC = () => {
  const { t } = useTranslation();
  // By rank, so a platform owner or super admin reads as an administrator too.
  const isAdminOrHigher = useCheckUserRole(Role.Admin);
  const isManager = useCheckUserRole(Role.Manager, { exact: true });

  const roleLabel = isAdminOrHigher
    ? t("userNotificationSettings.administrator")
    : isManager
      ? t("userNotificationSettings.manager")
      : t("userNotificationSettings.user");

  return (
    <PageContainer
      title={t("userNotificationSettings.notificationPreferences")}
    >
      <UserNotificationSettingsTable userRole={roleLabel} />
    </PageContainer>
  );
};

export default NotificationSettingsPage;
